import { SessionManager } from '@/services/SessionManager';
import { Configuration } from '@/infrastructure/api/client_typescript';
import { TokenStore } from '@/infrastructure/storage/TokenStore';

const baseUrl = import.meta.env.VITE_API_BASE_URL;

export const sessionManager = new SessionManager(
  new Configuration({ basePath: baseUrl }),
  new TokenStore()
);

void sessionManager.initializeSession();
